/* eslint-disable @typescript-eslint/no-explicit-any */

/* eslint-disable @typescript-eslint/ban-ts-comment */
import { QUOTES_URL } from "../utilities"
import CoverdashQuotes from "@coverdash/quotes"
import "@coverdash/quotes/lib/cjs/styles.css"
import * as Sentry from "@sentry/nextjs"
import type { GetServerSidePropsContext, NextPage } from "next"
import { NextSeo } from "next-seo"
import React from "react"

interface Props {
  referrer?: string
}
const Quote: NextPage = ({ referrer }: Props) => {
  const COMPONENT_ENV = QUOTES_URL.includes("staging")
    ? "staging"
    : QUOTES_URL.includes("uat")
    ? "uat"
    : "production"
  const [source, setSource] = React.useState<string | undefined>(referrer)
  React.useEffect(() => {
    const referrer = localStorage.getItem("referrer")
    if (referrer) {
      setSource(referrer)
    }
    const quotesIframe = document.getElementById("coverdash-quotes-component")
    // @ts-ignore
    if (quotesIframe.contentWindow?.postMessage) {
      setTimeout(() => {
        // @ts-ignore
        quotesIframe.contentWindow.postMessage(window.location.href, "*")
      }, 4000)
    }
    // window.addEventListener(
    //   'message',
    //   function (e) {
    //     if (isNaN(e.data)) return;
    //     // @ts-ignore
    //     quotesIframe.style.height = e.data + 'px';
    //   },
    //   false
    // );
  }, [])

  React.useEffect(() => {
    window.addEventListener("beforeunload", alertUser)
    return () => {
      window.removeEventListener("beforeunload", alertUser)
    }
  }, [])

  const alertUser = (e: any) => {
    e.preventDefault()
    e.returnValue = ""
  }

  return (
    <>
      <NextSeo
        title="Get a quote"
        description="Get a tailored business insurance quote online in minutes. Compare GL, BOP, cyber, and workers comp—then bind coverage when you are ready. — Coverdash"
        canonical="https://www.coverdash.com/quote"
        openGraph={{
          url: "https://www.coverdash.com/quote",
          title: "Get a quote",
          description:
            "Get a tailored business insurance quote online in minutes. Compare GL, BOP, cyber, and workers comp—then bind coverage when you are ready. — Coverdash",
        }}
      />
      {/* <Link href="/" passHref>
        <button
          className="rounded-full bg-alt text-white 
                    text-xs font-medium pr-4 py-1
                    hover:scale-105 ease-in-out duration-200 
                    absolute top-4 sm:left-10 left-1/3"
        >
          <div className="flex items-center">
            <ArrowSmLeftIcon className="w-5 h-5 ml-1 mr-2" />
            <span className="flex-1 leading-none cursor-pointer">
              Back to Coverdash
            </span>
          </div>
        </button>
      </Link> */}

      {/* max-w-[79rem]  */}
      {/* <iframe
        id="coverdash-quotes-component"
        // src={`https://quotes.coverdash.com?isDemo=false&hideChat=true&license=36864ed9-8a5e-4e2b-9759-5647c7a2b94e`}
        src={`http://localhost:3001?isDemo=false&hideChat=true&coverdashBackButton=true&license=36864ed9-8a5e-4e2b-9759-5647c7a2b94e&reset=true`}
        scrolling="yes"
        frameBorder="0"
        className={`h-screen mx-auto focus:outline-none focus:ring-0`}
      ></iframe> */}

      <CoverdashQuotes
        isDemo={false}
        allowScroll={true}
        autoResize={false}
        styles={{
          height: "100vh",
          marginLeft: "auto",
          marginRight: "auto",
        }}
        // coverdashBackButton={true}
        env={COMPONENT_ENV}
        license={process.env.NEXT_PUBLIC_QUOTES_LICENSE_KEY}
        // reset={false}
        // hideScrollbar
        source={source || ""}
        onApplicationSubmitted={(applicationId) => {
          // console.log('fallback log pre-if statement');
          // console.log(applicationId, process.env.NEXT_PUBLIC_VERCEL_ENV);
          if (
            applicationId &&
            process.env.NEXT_PUBLIC_VERCEL_ENV === "production"
          ) {
            // if (applicationId) {
            // console.log(applicationId, process.env.NEXT_PUBLIC_VERCEL_ENV);
            try {
              // @ts-ignore
              gtag("event", "conversion", {
                send_to: "AW-11072507410/NdF6CPur7IgYEJKc5J8p",
                value: 1.0,
                currency: "USD",
                transaction_id: "",
                event_callback: () => null,
              })
            } catch (error) {
              Sentry.captureException(error)
            }
          }
        }}
        onBoundPolicy={(bound) => {
          // console.log('fallback log pre-if statement');
          // console.log(bound, process.env.NEXT_PUBLIC_VERCEL_ENV);
          if (bound && process.env.NEXT_PUBLIC_VERCEL_ENV === "production") {
            // if (bound) {
            // console.log(bound, process.env.NEXT_PUBLIC_VERCEL_ENV);
            try {
              // @ts-ignore
              gtag("event", "conversion", {
                send_to: "AW-11072507410/y_5dCPir7IgYEJKc5J8p",
                value: 1.0,
                currency: "USD",
                transaction_id: "",
                event_callback: () => null,
              })
            } catch (error) {
              Sentry.captureException(error)
            }
          }
        }}
      />
      <button
        className="hidden"
        id="application-complete"
        onClick={() => {
          console.log("application complete")
        }}
      >
        Application Complete
      </button>
      <button
        className="hidden"
        id="policy-purchased"
        onClick={() => {
          console.log("policy purchased")
        }}
      >
        Policy Purchased
      </button>
    </>
  )
}

export default Quote

export const getServerSideProps = async (ctx: GetServerSidePropsContext) => {
  const query = ctx.query
  console.log(query)

  return {
    props: {
      referrer: query.ref || null,
    },
  }
}
